import contactData from "./contactData";

const offersData = {
  contact: {
    phoneNumber: `+91 ${contactData.phoneNumber}`,
  },
  offerData: [
    {
      title: "Combo Pack – Family Special",
      description: "Get 10% off on our most popular combo set. Perfect for family celebrations!",
      discount: "10%",
      code: "FAMILY20",
      image: "",
    },
    {
      title: "Buy 2 Get 1 Free",
      description: "Buy any two small bomb packets and get one free!",
      discount: "Buy 2 Get 1",
      code: "",
      image: "",
    },
    {
      title: "Festival Offer – ₹300 Cashback",
      description: "Get ₹300 cashback on orders above ₹3000. Limited time Diwali deal!",
      discount: "₹300 Cashback",
      code: "FEST300",
      image: "",
    },
  ],
};

export default offersData;